import course from './trackers/course';
import credit from './trackers/credit';
import engagement from './trackers/engagement';
import enterpriseDashboard from './trackers/enterpriseDashboard';
import entitlements from './trackers/entitlements';
import socialShare from './trackers/socialShare';
import findCourses from './trackers/findCourses';
import filter from './trackers/filter';

export default {
  course,
  credit,
  engagement,
  enterpriseDashboard,
  entitlements,
  socialShare,
  findCourses,
  filter,
};
